export const maskMobilePhone = (value: string) => {
  return value.replace(/^(\d{2})(\d{1})(\d{4})(\d{4})/, "($1) $2 $3-$4");
};

//máscara de telefone fixo
export const maskPhone = (value: string) => {
  return value.replace(/^(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
};
